export default "__VITE_ASSET__E$zLJ6xU__"